import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App__deck';
import { IS_DEVELOPMENT, SENTRY_DSN } from './constants/env';

if (!IS_DEVELOPMENT)
  Sentry.init({
    dsn: SENTRY_DSN
  });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
